module.exports = __webpack_public_path__ + "img/yamada-ha-india.7dd25d09.png";